<template>
  <el-dialog :visible.sync="innerVisible" :title="$t('SeaExport.Refuse')" width="400px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <div>
      <span>{{ rejectTips }}</span>
      <span>
        <el-input v-model="remark" no="1" type="textarea" :rows="10" />
      </span>
    </div>
    <span slot="footer" style="padding:10px;">
      <el-button no="2" type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="3" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: 'OpVerifyFrameReject',
  components: { },
  props: {
    visible: { type: Boolean, default: () => false },
    jobNo: { type: String, default: () => ('') },
    rejectCallBack: { type: Function, default: () => (null) },
    type: { type: String, default: () => ('') },
    jobList: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      rejectTips: '',
      remark: ''
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (this.jobList && this.jobList.length > 0) {
          this.rejectTips = this.$t('SeaExport.RejectTips', [this.$t('CargoMsg.Cargo_SelectedBusiness')])
        } else {
          this.rejectTips = this.$t('SeaExport.RejectTips', [this.jobNo])
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
  },
  methods: {
    handleSubmit() {
      if (this.type === 'fba' && this.remark.length === 0) {
        this.$message.warning(this.$t('ChangeCharge.businessAuditReasonNotNull'))
        return
      }
      if (this.rejectCallBack) {
        this.rejectCallBack(this.remark)
      }
      this.handleClose()
    },
    handleClose() {
      this.remark = ''
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .cargo-form{
    .el-form-item {
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
